import { combineReducers } from '@reduxjs/toolkit';
import getCertificateInfoSlice from './CertificateSlice';

export default combineReducers({
    verify: getCertificateInfoSlice,
});
